import React, { useContext, useState } from 'react';
import { ThemeContext } from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';

import { bool } from 'prop-types';

import { ThemePropType } from 'assets/styles/theme';

import {
  BasicInfoWizard,
  FinanceInfoWizard,
  ContractInfoWizard,
  SolutionInfoWizard,
  withWizard,
} from 'containers';
import {
  Completed,
  ContentWithHeader,
  StepHeader,
  StepHeaderItem,
} from 'components';
import { changeStep } from 'store/modules';

export const steps = [
  {
    id: 0,
    content: (props) => <BasicInfoWizard {...props} />,
    title: 'Dados Cadastrais',
  },
  {
    id: 1,
    content: (props) => <SolutionInfoWizard {...props} />,
    title: 'Produtos',
  },
  {
    id: 2,
    content: (props) => <FinanceInfoWizard {...props} />,
    title: 'Financeiro',
  },
  {
    id: 3,
    content: (props) => <ContractInfoWizard {...props} />,
    title: 'Contrato',
  },
];

const Navigation = ({ theme, disabled, fullCompleted }) => {
  const { parentCurrentStep: currentStep } = useSelector((state) => state.subscription);
  return (
    <StepHeader theme={theme}>
      {steps.map((step, index) => (
        <StepHeaderItem
          theme={theme}
          key={`step-header-item-${step.title}`}
          step={index}
          title={step.title}
          disabled={disabled}
          completed={currentStep > index || fullCompleted}
          active={index === currentStep}
        />
      ))}
    </StepHeader>
  );
};

Navigation.defaultProps = {
  disabled: false,
  theme: null,
};

Navigation.propTypes = {
  theme: ThemePropType,
  disabled: bool,
};

export default function Subscription() {
  const theme = useContext(ThemeContext);
  const [completed, setCompleted] = useState(false);
  const [completedInfo, setCompletedInfo] = useState(null);
  const [enabled] = useState(false);
  const dispatch = useDispatch();

  const renderContent = ({ enable, disabled, children }) => {
    if (completed) return (
      <Completed managerName={completedInfo?.managerName} managerEmail={completedInfo?.managerEmail} />
    );

    return children;
  };

  return (
    <ContentWithHeader
      callToActionText="Siga o passo a passo para finalizar seu cadastro."
      navigation={(
        <Navigation
          disabled={!enabled}
          fullCompleted={completed}
        />
      )}
    >
      {withWizard({
        type: 'MASTER',
        disabled: !enabled,
        initialValues: {},
        steps,
        theme,
        onStepChanged: ({ currentStep: step }) => {
          dispatch(changeStep({ parentCurrentStep: step }));
        },
        complete: ({ managerName, managerEmail } = {}) => {
          setCompletedInfo({ managerName, managerEmail });
          dispatch(changeStep({ parentCurrentStep: steps.length - 1 }));
          setCompleted(true);
        },
      })(renderContent)}
    </ContentWithHeader>
  );
}
